import React, { useEffect, useState } from 'react'
import { MapContainer, Marker, Popup, TileLayer, useMap } from 'react-leaflet'

import { Box, Theme, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { LatLng } from 'leaflet'
import DOMPurify from 'dompurify'

interface IProps {
  positions: LatLng[]
  label?: string[]
  height?: number
  mapZoom?: number
}

const LocationMap: React.FC<IProps> = (props) => {
  const useStyles = makeStyles((theme: Theme) => ({
    map: {
      height: props.height ? `${props.height}px` : '40vh',
      width: '100%',
      borderRadius: 2,
      borderWidth: 'thin',
    },
    mapBox: {
      height: props.height ? `${props.height}px` : '40vh',
    },

  }))

  const classes = useStyles()

  const { positions } = props
  const mapZoom = props.mapZoom || 12

  const [isCssElementLoaded, setCssElementLoaded] = useState(false)

  useEffect(() => {
    const linkElement = document.createElement('link')
    linkElement.setAttribute('rel', 'stylesheet')
    linkElement.setAttribute('type', 'text/css')
    linkElement.setAttribute(
      'href',
      'https://unpkg.com/leaflet@1.7.1/dist/leaflet.css',
    )
    document.head.appendChild(linkElement)
    setCssElementLoaded(true)
  }, [])

  const [isScriptElementLoaded, setScriptElementLoaded] = useState(false)

  useEffect(() => {
    const linkElement = document.createElement('script')
    linkElement.setAttribute('type', 'text/javascript')
    linkElement.setAttribute(
      'src',
      'https://unpkg.com/leaflet@1.7.1/dist/leaflet.js',
    )
    document.head.appendChild(linkElement)
    setScriptElementLoaded(true)
  }, [])

  function ChangeMapView () {
    const map = useMap()
    map.flyTo(positions[0], map.getZoom())
    return null
  }

  const LocationMarker = (): JSX.Element => {
    return (
      <>
        {
          (positions && positions.length === 0) ? null : (
            positions.map((position, index) => {
              const label = props.label && props.label[index] ? props.label[index] : 'Familienskatturnier'
              return (
                <Box key={index}>
                  <Marker position={position}>
                    <Popup>
                      <Typography
                        variant='body1'
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(label as string) }}
                      />
                    </Popup>
                  </Marker>
                </Box>
              )
            },
            ))
        }
      </>
    )
  }

  return (
    <>
      {isCssElementLoaded && isScriptElementLoaded &&
        <Box className={classes.mapBox}>
          <MapContainer className={classes.map} center={positions[0]} zoom={mapZoom}>
            <TileLayer
              attribution='&copy <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
            />
            {positions.length === 1 &&
              <ChangeMapView />}
            <LocationMarker />
          </MapContainer>
        </Box>}
    </>
  )
}

export default LocationMap
